module.exports = __webpack_public_path__ + "img/chevron-right-thin.3f37b275.svg";